import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import IconTicketEscalation from '../../assets/icons/IconTicketEscalation';

class TicketEscalationListCSO extends Component {
    render() {
        return (
            <>
                {/* Dashboard Ticket Escalation */}
                <div className="bg-white rounded-md shadow-lg relative col-span-2">
                    <div className="text-nexcareblue1 p-7">
                        <div className="text-xl font-bold flex items-center pb-5">
                            {
                                this.props.loading
                                    ? <Skeleton height={40} width={40} />
                                    : <IconTicketEscalation />
                            }
                            {
                                this.props.loading
                                    ? <Skeleton height={20} width={120} className="ml-2" />
                                    : <p className="pl-3">Eskalasi</p>
                            }
                        </div>

                        {
                            this.props.loading
                                ? <div className="flex justify-between items-center">
                                    <div className="w-1/2 pr-0.5"><Skeleton height={20} count={10} /></div>
                                    <div className="w-1/2 pl-0.5"><Skeleton height={20} count={10} /></div>
                                </div>
                                : <div>
                                    {
                                        this.props.data.length > 0
                                            ? <div className="font-medium text-lg grid grid-cols-2 w-full">
                                                {
                                                    this.props.data.map((item, index) => {
                                                        return (
                                                            <div className={index % 2 === 0 ? "text-left" : "text-right"} key={index}>
                                                                {item.ticket_no}
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            : <div className="font-medium text-lg h-60 overflow-auto flex justify-center items-center">
                                                <p className="text-darkgrey">Tidak ada data</p>
                                            </div>
                                    }
                                </div>
                        }
                    </div>
                </div>
            </>
        );
    }
}

export default TicketEscalationListCSO;